import Hero from '../components/Hero'
import Introduction from '../components/Introduction'
import Services from '../components/Services'
import HomeNavigation from '../components/HomeNavigation'

const Home = () => {
  return (
    <div>
      <HomeNavigation />
      <Hero />
      <Introduction />
      <Services />
    </div>
  )
}

export default Home
